module.exports = __webpack_public_path__ + "img/CATEGORY ICON-02.2c5dd649.png";